module.exports = __webpack_public_path__ + "img/proEmpty.98a467a5.png";